import { styled } from '@mui/material';

export const CharactersWrapper = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
}));
